import React from "react";
import './header.css';
import {NavLink} from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';

// ...... images ........
import downArrow from '../../assets/images/down-arrow.svg';
import how from '../../assets/images/how.svg';
import feature from '../../assets/images/features.svg';
import interactive from '../../assets/images/interactive-black.svg';
import integrations from '../../assets/images/integrations.svg';
import file from '../../assets/images/file.svg';
import marketing from '../../assets/images/marketing-speaker.svg';
import sales from '../../assets/images/sales.svg';
import customer from '../../assets/images/customer.svg';
import support from '../../assets/images/support.svg';
import training from '../../assets/images/training.svg';
import product from '../../assets/images/product.svg';
import salesEnabled from '../../assets/images/sales-enabled.svg';
import onBoard from '../../assets/images/customers.svg';
import drive from '../../assets/images/drive.svg';
import knowledge from '../../assets/images/knowledge.svg';
import customizedDemo from '../../assets/images/customized-demo.svg'
import selfGuidedTour from '../../assets/images/self-guided-tour.svg'


function Header() {
   return (
       <div className="content-box">
          <header className="flex hr-space-between header">
             <div className="logo rubik-bold font-24">
                <NavLink to={'/home'} className="highlight-color">Floik</NavLink>
             </div>
             <nav className="nav-bar flex font-15">
                <div className="nav">
                   <NavLink to={'/home'} className="nav-link flex">
                      <div className="">Platform</div>
                      <div className="icon arrow-icon">
                        <img src={downArrow} alt=""/>
                      </div>
                   </NavLink>
                   <div className="sub-nav">
                      <div className="flex align-stretch">
                         <div className="sub-nav-content">
                            <ul className="links">
                               <li>
                                  <NavHashLink className={''} to={'/home/#how-it-works'}
                                               scroll={(el) => el.scrollIntoView({ behavior: 'smooth'})}>
                                     <div className="icon">
                                        <img src={how} alt=""/>
                                     </div>
                                     <div className="">How it works</div>
                                  </NavHashLink>
                               </li>
                               <li>
                                  <NavHashLink className={''} to={'/home/#features'}
                                               scroll={(el) => el.scrollIntoView({ behavior: 'smooth'})}>
                                     <div className="icon">
                                        <img src={feature} alt=""/>
                                     </div>
                                     <div className="">Features</div>
                                  </NavHashLink>
                               </li>
                               <li>
                                  <NavHashLink className={''} to={'/home/#interactive-videos'}
                                               scroll={(el) => el.scrollIntoView({ behavior: 'smooth'})}>
                                     <div className="icon">
                                        <img src={interactive} alt=""/>
                                     </div>
                                     <div className="">Interactive videos</div>
                                  </NavHashLink>
                               </li>
                               <li>
                                  <NavHashLink className={''} to={'/home/#integrations'}
                                               scroll={(el) => el.scrollIntoView({ behavior: 'smooth'})}>
                                     <div className="icon">
                                        <img src={integrations} alt=""/>
                                     </div>
                                     <div className="">Integrations</div>
                                  </NavHashLink>
                               </li>
                            </ul>
                         </div>
                         <div className="sub-nav-content border-left">
                            <div className="sub-nav-heading">What’s coming soon</div>
                            <ul className="links coming-up">
                               <li className={'flex'}>
                                  <div className="icon">
                                     <img src={file} alt=""/>
                                  </div>
                                  <div className="">How it works</div>
                               </li>
                               <li className={'flex'}>
                                  <div className="icon">
                                     <img src={customizedDemo} alt=""/>
                                  </div>
                                  <div className="">Customised demo</div>
                               </li>
                               <li className={'flex'}>
                                  <div className="icon">
                                     <img src={selfGuidedTour} alt=""/>
                                  </div>
                                  <div className="">Self Guided Tour</div>
                               </li>
                            </ul>
                         </div>
                      </div>
                   </div>
                </div>
                <div className="nav">
                   <NavLink to={'/useCase'} className="nav-link flex">
                      <div className="">Solutions</div>
                      <div className="icon arrow-icon">
                        <img src={downArrow} alt=""/>
                      </div>
                   </NavLink>
                   <div className="sub-nav">
                      <div className="flex align-stretch">
                         <div className="sub-nav-content">
                            <div className="sub-nav-heading">BY ROLE</div>
                            <ul className="links">
                               <li>
                                  <NavLink to={'/useCase'}>
                                     <div className="icon">
                                        <img src={marketing} alt=""/>
                                     </div>
                                     <div className="">Marketing</div>
                                  </NavLink>
                               </li>
                               <li>
                                  <NavLink className={''} to={'/sales'}>
                                     <div className="icon">
                                        <img src={sales} alt=""/>
                                     </div>
                                     <div className="">Sales</div>
                                  </NavLink>
                               </li>
                               <li>
                                  <NavLink className={''} to={'/customer-success'}>
                                     <div className="icon">
                                        <img src={customer} alt=""/>
                                     </div>
                                     <div className="">Customer success</div>
                                  </NavLink>
                               </li>
                               <li>
                                  <NavLink className={''} to={'/support'}>
                                     <div className="icon">
                                        <img src={support} alt=""/>
                                     </div>
                                     <div className="">Support</div>
                                  </NavLink>
                               </li>
                               <li>
                                  <NavLink className={''} to={'/training'}>
                                     <div className="icon">
                                        <img src={training} alt=""/>
                                     </div>
                                     <div className="">Training</div>
                                  </NavLink>
                               </li>
                            </ul>
                         </div>
                         <div className="sub-nav-content">
                            <div className="sub-nav-heading">By Use cases</div>
                            <ul className="links">
                               <li>
                                  <NavLink className={''} to={''}>
                                     <div className="icon">
                                        <img src={product} alt=""/>
                                     </div>
                                     <div className="">Product walkthroughs</div>
                                  </NavLink>
                               </li>
                               <li>
                                  <NavLink className={''} to={''}>
                                     <div className="icon">
                                        <img src={salesEnabled} alt=""/>
                                     </div>
                                     <div className="">Sales enablement</div>
                                  </NavLink>
                               </li>
                               <li>
                                  <NavLink className={''} to={''}>
                                     <div className="icon">
                                        <img src={onBoard} alt=""/>
                                     </div>
                                     <div className="">Onboard customers</div>
                                  </NavLink>
                               </li>
                               <li>
                                  <NavLink className={''} to={''}>
                                     <div className="icon">
                                        <img src={drive} alt=""/>
                                     </div>
                                     <div className="">Drive product adoption</div>
                                  </NavLink>
                               </li>
                               <li>
                                  <NavLink className={''} to={''}>
                                     <div className="icon">
                                        <img src={knowledge} alt=""/>
                                     </div>
                                     <div className="">Update knowledge base</div>
                                  </NavLink>
                               </li>
                            </ul>
                         </div>
                      </div>
                   </div>
                </div>
                <div className="nav"><NavLink className={'nav-link'} to="/pricing">Pricing</NavLink></div>
                <div className="nav"><NavLink className={'nav-link'} to={'/blogs'}>Blog</NavLink></div>
                <div className="btn round-corner-8 item-height-40 font-14">Get Early Access</div>
             </nav>
             <ul className="menuBtn" data-init="0">
                <li></li>
                <li></li>
                <li></li>
             </ul>

             
          </header>
       </div>
   )
}

export default Header;
